/**
 * Delay Load – initializes third-party scripts (Trustpilot, chat, marketing widgets)
 * only after the first user interaction (scroll, mousemove, touchstart, keydown).
 * Reduces Total Blocking Time (TBT) by keeping the main thread free for initial render.
 */
(function () {
  'use strict';

  var queue = [];
  var done = false;
  var opts = window.themeDelayLoadOpts || { fallbackMs: 0 };

  function trigger() {
    if (done) return;
    done = true;
    removeListeners();
    queue.forEach(function (item) {
      if (item.url) loadScript(item.url, item.id, item.async);
      if (typeof item.cb === 'function') item.cb();
    });
    queue = [];
  }

  function loadScript(url, id, async) {
    if (!url || document.querySelector('script[src="' + url + '"]')) return;
    var s = document.createElement('script');
    s.src = url;
    s.async = async !== false;
    if (id) s.id = id;
    document.body.appendChild(s);
  }

  function removeListeners() {
    window.removeEventListener('scroll', onScroll, { passive: true });
    window.removeEventListener('mousemove', trigger, { passive: true });
    window.removeEventListener('touchstart', trigger, { passive: true });
    window.removeEventListener('keydown', trigger);
  }

  function onScroll() {
    if (window.scrollY > 0 || window.scrollX > 0) trigger();
  }

  window.themeDelayLoad = function (url, callbackOrOpts, maybeCallback) {
    var id = null;
    var async = true;
    var cb = null;
    if (typeof callbackOrOpts === 'function') {
      cb = callbackOrOpts;
    } else if (callbackOrOpts && typeof callbackOrOpts === 'object') {
      id = callbackOrOpts.id;
      async = callbackOrOpts.async !== false;
      cb = maybeCallback;
    }
    var item = { url: url, id: id, async: async, cb: cb };
    if (done) {
      if (item.url) loadScript(item.url, item.id, item.async);
      if (typeof item.cb === 'function') item.cb();
    } else {
      queue.push(item);
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('mousemove', trigger, { passive: true });
  window.addEventListener('touchstart', trigger, { passive: true });
  window.addEventListener('keydown', trigger);

  if (opts.fallbackMs > 0) {
    window.setTimeout(trigger, opts.fallbackMs);
  }
})();
